import { render, staticRenderFns } from "./caseSingleText.vue?vue&type=template&id=92cc8130&lang=pug"
import script from "./caseSingleText.vue?vue&type=script&lang=js"
export * from "./caseSingleText.vue?vue&type=script&lang=js"
import style0 from "./caseSingleText.vue?vue&type=style&index=0&id=92cc8130&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports